import React from "react";
import { IconName } from "../../lib/svgIcon/components";
import createSvgIcon from "../../lib/svgIcon/utils/createSvgIcon";

const staticIcons: {
  [key in IconName]?: ReturnType<typeof createSvgIcon>;
} = {
  home_96: createSvgIcon(
    <>
      <path
        d="M18.5 38L18.5 80C18.5 81.1046 19.3954 82 20.5 82H76.5C77.6046 82 78.5 81.1046 78.5 80V38"
        stroke="#93826F"
        stroke-width="2"
        stroke-linecap="round"
      />
      <line
        x1="20.5"
        y1="75"
        x2="76.5"
        y2="75"
        stroke="#93826F"
        stroke-width="2"
      />
      <path
        d="M24.4711 14.0496L10.5877 37.8496C10.5488 37.9163 10.5969 38 10.6741 38H86.3259C86.4031 38 86.4512 37.9163 86.4123 37.8496L72.5289 14.0496C72.511 14.0189 72.4781 14 72.4426 14H24.5574C24.5219 14 24.489 14.0189 24.4711 14.0496Z"
        stroke="#93826F"
        stroke-width="2"
      />
      <line
        x1="37.5"
        y1="40"
        x2="37.5"
        y2="72"
        stroke="#93826F"
        stroke-width="2"
      />
      <path
        d="M66.5 56L58.5 64"
        stroke="#93826F"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M64.5 48L48.5 64"
        stroke="#93826F"
        stroke-width="2"
        stroke-linecap="round"
      />
    </>,
    "Home96Icon",
    {
      width: "97",
      height: "96",
      viewBox: "0 0 97 96",
    }
  ),
  device: createSvgIcon(
    <>
      <path d="M28 29V71H2V29H28Z" stroke="#93826F" stroke-width="2" />
      <line x1="48" y1="67" x2="48" y2="51" stroke="#93826F" stroke-width="2" />
      <path d="M37 66H61" stroke="#93826F" stroke-width="2" />
      <path
        d="M37 50H78C78.5523 50 79 49.5523 79 49V3C79 2.44771 78.5523 2 78 2H12C11.4477 2 11 2.44772 11 3V20"
        stroke="#93826F"
        stroke-width="2"
      />
    </>,
    "DeviceIcon",
    {
      width: "81",
      height: "74",
      viewBox: "0 0 81 74",
    }
  ),
  app: createSvgIcon(
    <>
      <rect
        x="29"
        y="14"
        width="40"
        height="68"
        rx="1"
        stroke="#93826F"
        stroke-width="2"
      />
      <line x1="28" y1="70" x2="70" y2="70" stroke="#93826F" stroke-width="2" />
    </>,
    "AppIcon",
    {
      width: "97",
      height: "96",
      viewBox: "0 0 97 96",
    }
  ),
};

export default staticIcons;
